<template>
  <div
    v-if="item.children && !item.hidden"
    class="menu-dropdown"
    :class="{
      'menu-element': !isExtended && level <= 1,
      'extended-menu-element': isExtended && level <= 1,
      'submenu-element': level > 1,
      'submenu-element-in-menu': level > 1 && asMenu,
      'submenu-element-in-menu': level > 1 && asMenu,
    }"
  >
    <div
      v-b-tooltip.hover.html="
        level == 1 && !isExtended
          ? { variant: 'base', placement: 'righttop', boundary: 'viewport',customClass: 'secondary-navigation-menu-item' }
          : {}
      "
      :title="level == 1 && !isExtended ? item.name : ''"
      class="menu-trigger"
      :class="{
        'current-route': isCurrentRoute,
      }"
      @click="toggleSubmenu"
      :ref="item.name"
    >
      <div class="d-flex align-items-center justify-content-between w-100">
        <div
          class="d-flex align-items-center w-100 hover"
          :class="{
            sideline: isActive && level === 1,
            sidedot: level > 1 && level < 3 && (isActive || isCurrentRoute),
            'active-item-padding':
              (isExtended && level > 2 && level < 3 && (isActive || isCurrentRoute)) ||
              (asMenu && level > 1 && level < 3 && (isActive || isCurrentRoute)),
          }"
          :style="{ paddingLeft: `${additionalPaddingLeft}px` }"
        >
          <div
            v-if="item.iconName && level === 1"
            :style="{
              padding: iconPadding,
              borderRadius: '5px',
            }"
            class="d-flex align-items-center justify-content-center"
          >
            <SecondaryNavigationMenuItemIcon
              class="menu-icon"
              :name="item.iconName"
              :variant="isActive ? 'isActive' : 'default'"
            />
          </div>
          <template v-if="isExtended">
            <div
              v-if="level > 0"
              class="d-flex align-items-center justify-content-between w-100 menu-item-name"
              :class="{ 'pl-2 py-2': level > 1 }"
            >
              <span class="item-title">{{ item.name }}</span>
              <span
                v-if="level > 0"
                class="material-icons transition mr-1"
                :style="{
                  transform: showSubmenu && level < 2 ? 'rotate(-90deg)' : 'rotate(0deg)',
                }"
              >
                chevron_right
              </span>
            </div>
          </template>
          <template v-else>
            <div
              v-if="level > 1"
              class="d-flex align-items-center justify-content-between w-100 menu-item-name pl-2 py-2"
            >
              <span class="item-title">{{ item.name }}</span>
              <span class="material-icons"> chevron_right </span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <template v-if="isExtended">
      <div
        v-if="level > 1"
        v-show="showSubmenu"
        class="submenu"
        :class="{
          'submenu-right': level > 1,
        }"
        :style="{ top: menuOffsetTop, left: menuOffsetLeft }"
      >
        <SecondaryNavigationMenuItem
          v-for="(child, idx) in item.children"
          :key="`${level}-${idx}`"
          :item="child"
          :level="level + 1"
          :dir="dir"
          @close-all="closeAll"
          :isExtended="isExtended"
          :menu="item"
          :asMenu="true"
          :additionalPaddingLeft="0"
        />
      </div>
      <div
        v-else
        v-show="showSubmenu"
        :style="{
          marginTop: level > 2 ? '0px' : '4px',
        }"
        class="nav-line"
      >
        <SecondaryNavigationMenuItem
          v-for="(child, idx) in item.children"
          :key="`${level}-${idx}`"
          :item="child"
          :level="level + 1"
          :dir="dir"
          @close-all="() => {}"
          :isExtended="isExtended"
          :menu="item"
          :additionalPaddingLeft="!asMenu && !showSubmenu ? 0 : 18"
        />
      </div>
    </template>
    <template v-else>
      <div
        v-show="showSubmenu"
        class="submenu"
        :class="{
          'submenu-right': level > 0,
        }"
        :style="{ top: menuOffsetTop, left: menuOffsetLeft }"
      >
        <SecondaryNavigationMenuItem
          v-for="(child, idx) in item.children"
          :key="`${level}-${idx}`"
          :item="child"
          :level="level + 1"
          :dir="dir"
          @close-all="closeAll"
          :isExtended="isExtended"
          :menu="item"
          :asMenu="true"
          :additionalPaddingLeft="0"
        />
      </div>
    </template>
  </div>

  <div
    v-else-if="!item.hidden"
    class="hover"
    :class="{
      'menu-element': !isExtended && level <= 1,
      'extended-menu-element': isExtended && level <= 1,
      'submenu-element': level > 1 && !asMenu,
      'submenu-element-in-menu': level > 1 && asMenu,
      'current-route': isCurrentRoute,
      sidedot: level > 1 && level < 3 && isActive,
      'active-item-padding':
        (isExtended && level > 2 && level < 3 && isActive) ||
        (asMenu && level > 1 && level < 3 && isActive),
      sideline: level === 1 && isActive,
    }"
    v-b-tooltip.hover.html="
      level == 1 && !isExtended
        ? { variant: 'base', placement: 'righttop', boundary: 'viewport', customClass: 'secondary-navigation-menu-item' }
        : {}
    "
    :title="level == 1 && !isExtended ? item.name : ''"
    :style="{ paddingLeft: `${additionalPaddingLeft}px` }"
  >
    <router-link
      :to="{ name: item.route }"
      class="navbar-link"
      @click.native="handleItemClick"
      :class="{ 'pl-2 py-2': level > 1 }"
    >
      <div class="d-flex align-items-center">
        <div
          v-if="item.iconName && level === 1"
          :style="{
            padding: iconPadding,
            borderRadius: '5px',
          }"
          class="d-flex align-items-center justify-content-center menuOffsetTop"
        >
          <SecondaryNavigationMenuItemIcon
            class="menu-icon"
            :name="item.iconName"
            :variant="showSubmenu || isActive ? 'isActive' : 'default'"
          />
        </div>
        <div v-if="isExtended || level > 1" class="menu-item-name">
          <span class="item-title">{{ item.name }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import SecondaryNavigationMenuItemIcon from './SecondaryNavigationMenuItemIcon.vue'
export default {
  name: 'SecondaryNavigationMenuItem',
  components: { SecondaryNavigationMenuItemIcon },
  props: {
    isExtended: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    dir: {
      type: String,
      default: 'right'
    },
    asMenu: {
      type: Boolean,
      default: false
    },
    additionalPaddingLeft: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      showSubmenu: false,
      menuOffsetTop: '0px',
      menuOffsetLeft: '0px'
    }
  },
  computed: {
    isCurrentRoute () {
      return this.$route.name === this.item.route
    },
    isActive () {
      return this.checkActive(this.item)
    },
    iconPadding () {
      if (this.isExtended) {
        if (this.level === 1) {
          return '8px 4px 8px 8px'
        } else {
          return '8px 8px 8px 8px'
        }
      } else if (this.asMenu) {
        if (this.level === 1) {
          return '8px 8px 8px 8px'
        } else {
          return '8px 8px 8px 8px'
        }
      }

      return '8px'
    }
  },
  mounted () {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleOutsideClick)
    this.showSubmenu = false
  },
  watch: {
    showSubmenu (newValue) {
      if (newValue) {
        const rect = this.$refs[this.item.name].getBoundingClientRect()
        this.menuOffsetTop = `${rect.top - (this.level > 1 ? 8 : 2)}px`
        this.menuOffsetLeft = `${
          rect.right +
          (this.level > 1
            ? this.isExtended
              ? 12
              : 14
            : this.isExtended
              ? 14
              : 12)
        }px`
      }
    }
  },
  methods: {
    checkActive (item) {
      if (item.route && this.isCurrentRoute) {
        return true
      }
      if (item.children) {
        const isActiveChild = item.children.some((c) => {
          if (c.route === this.$route.name) {
            return true
          }
        })

        return isActiveChild || item.children.some((c) => this.checkActive(c))
      }
      return false
    },
    toggleSubmenu () {
      this.showSubmenu = !this.showSubmenu
    },
    handleOutsideClick (event) {
      if (this.level > 1 || this.isExtended === false) {
        if (this.$el && !this.$el.contains(event.target)) {
          this.showSubmenu = false
        }
      }
    },
    handleItemClick () {
      this.$emit('close-all')
    },
    closeAll () {
      this.showSubmenu = false
      this.$emit('close-all')
    }
  }
}
</script>

<style scoped lang="scss">
.item-title {
  font-size: 13px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
}

.hover {
  transition: 0.2s;
}

.hover:hover {
  background-color: #eaedf4;
  color: $fontColorBase !important;
  text-shadow: 0 0 0.5px currentColor, 0 0 0.5px currentColor;
  .menu-icon {
    color: $fontColorBase !important;
  }
}

.menu-element + .menu-element {
  margin-top: 8px;
}

.extended-menu-element + .extended-menu-element {
  margin-top: 8px;
}

.submenu-element + .submenu-element {
  margin-top: 4px !important;
}

.submenu-element-in-menu + .submenu-element-in-menu {
  margin-top: 4px !important;
}

.transition {
  transition: all 0.2s;
}

.item-margin {
  margin-left: 8px;
}

.item-margin-left {
  margin-left: 8px;
  margin-right: 8px;
}

.navbar-link {
  cursor: pointer;
  white-space: nowrap;
  color: $fontColorBase;
  font-size: 15px;
  font-weight: 400;
  text-decoration: none;
  display: flex;
  line-height: 23px;

  :global(.btn) {
    font-size: inherit;
  }
}

.current-route {
  color: $iconColor !important;
  background-color: #e4efff;
  text-shadow: 0 0 0.5px currentColor, 0 0 0.5px currentColor;
  position: relative;
}

.sideline {
  position: relative;
  color: $iconColor !important;
  text-shadow: 0 0 0.5px currentColor, 0 0 0.5px currentColor;
}

.sideline::before {
  position: absolute;
  content: "";
  height: 100%;
  width: 2px;
  left: 0px;
  background-color: $buttonBgColor1;
}

.sidedot {
  position: relative;
  transition: 0.2s;
  text-shadow: 0 0 0.5px currentColor, 0 0 0.5px currentColor;
}

.sidedot .item-title {
  color: $iconColor !important;
}

.active-item-padding .item-title {
  padding-left: 16px !important;
}

.sidedot::before {
  position: absolute;
  content: "";
  top: calc(100% - 24px);
  height: 8px;
  width: 8px;
  left: 9px;
  border-radius: 100%;
  z-index: 222;
  background-color: $buttonBgColor1;
  animation: fade 0.2s forwards;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.nav-line {
  position: relative;
}

.nav-line::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 100%;
  background-color: $bgColor2;
  z-index: 123;
  left: 12px;
}

.menu-dropdown {
  position: relative;
  display: block;
}

.menu-trigger {
  transition: all 0.2s ease;
  cursor: pointer;
}

.menu-arrow {
  font-size: 12px;
  transition: transform 0.2s ease;
}

.menu-arrow.rotated {
  transform: rotate(90deg);
}

.submenu {
  position: relative;
  min-width: 100px;
  width: max-content;
  background: white;
  border-radius: 5px;
  box-shadow: 4px 4px 10px 0 rgba(208, 208, 208, 0.3);
  z-index: 1000;
  padding: 8px;

  & .navbar-link,
  & .menu-trigger {
    color: $buttonTxtColor2;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
  }
}

.submenu .current-route .navbar-link {
  color: $iconColor !important;
}

.submenu-below {
  top: 100%;
  left: 0;
  margin-top: 20px;
}

.submenu-right {
  position: fixed;
  z-index: 2000;
}

.submenu-left {
  top: 0;
  right: 100%;
  margin-right: 12px;
}

</style>
